import React from "react";
import { Route, Redirect } from "react-router-dom";
import { isAuthenticated } from "../../helpers/session";
import { redirectRoute } from "../routes";

const Public = ({ component: Component, ...rest }) => {
  if (isAuthenticated()) {
    return <Redirect to={redirectRoute.private} />;
  }

  return <Route {...rest} component={Component} />;
};

export default Public;
